import api from '@pray/shared/utils/api';

import type { CreateRecurringPushCampaignPayload, RecurringPushCampaignDetail } from './types';

// POST …/campaigns/recurring-push — creates a `draft` + its audiences in one txn,
// then the controller re-reads and serializes the full detail DTO.
export async function createRecurringPushCampaign({
  artistId,
  payload,
}: {
  artistId: string;
  payload: CreateRecurringPushCampaignPayload;
}): Promise<{ object: RecurringPushCampaignDetail }> {
  if (!artistId) throw new Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/campaigns/recurring-push`;
  const response = await api.executePostRequest<{ data: { object: RecurringPushCampaignDetail } }>(url, payload);
  return response.data.data;
}
